import { useCallback, useEffect, useState } from 'react'
import { fetchCsAccounts, type CsAccountSummary, type CsCarteiraStage } from '@/services/csService'

export function useCsCarteiraPage() {
  const [accounts, setAccounts] = useState<CsAccountSummary[]>([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [stage, setStage] = useState<CsCarteiraStage | ''>('')
  const [riscoOnly, setRiscoOnly] = useState(false)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const result = await fetchCsAccounts({
        search: search.trim() || undefined,
        stage: stage || undefined,
        riscoChurn: riscoOnly ? true : undefined,
      })
      setAccounts(result.data)
    } catch {
      setAccounts([])
    } finally {
      setLoading(false)
    }
  }, [search, stage, riscoOnly])

  useEffect(() => {
    const t = window.setTimeout(load, search ? 300 : 0)
    return () => window.clearTimeout(t)
  }, [load, search])

  return {
    accounts,
    loading,
    search,
    setSearch,
    stage,
    setStage,
    riscoOnly,
    setRiscoOnly,
    reload: load,
  }
}
